<template>
    <v-group>
        <v-image :config="tmpConfig.tmpIncrease" @click="executeAction('increment')" />
        <v-image :config="tmpConfig.tmpDecrease" @click="executeAction('decrement')" />
        <v-image :config="tmpConfig.tmpUndo" @click="executeAction('undo')" />
        <v-image :config="tmpConfig.tmpRedo" @click="executeAction('redo')" />
    </v-group>
</template>

<script>
import { mapState } from 'vuex';

// TODO: #13: make the ActionMenu reactive to actions passed to it
export default {
    props: {
        actions: {
            type: Object,
            required: true,
        },
        gridSpace: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {};
    },
    computed: {
        ...mapState('gamestate', {
            entities: 'entities',
        }),
        tmpConfig() {
            const size = 25;
            const spacing = 5;
            const offsetY = this.gridSpace.size / 2 + size + 6.25;
            const tmpIncrease = {
                image: this.entities.plusButton.asset['@data'],
                width: size,
                height: size,
                offsetX: 20,
                offsetY,
            };
            const tmpDecrease = {
                image: this.entities.minusButton.asset['@data'],
                width: size,
                height: size,
                offsetX: 20 - (size + spacing),
                offsetY,
            };
            const tmpUndo = {
                image: this.entities.undoButton.asset['@data'],
                width: size,
                height: size,
                offsetX: 20 - (size + spacing) * 2,
                offsetY,
            };
            const tmpRedo = {
                image: this.entities.redoButton.asset['@data'],
                width: size,
                height: size,
                offsetX: 20 - (size + spacing) * 3,
                offsetY,
            };
            return {
                tmpIncrease: tmpIncrease,
                tmpDecrease: tmpDecrease,
                tmpUndo: tmpUndo,
                tmpRedo: tmpRedo,
            };
        },
    },
    methods: {
        executeAction(actionID) {
            const action = this.actions[actionID];
            this.$emit('request-action-resolution', action);
        },
    },
};
</script>
